module.exports = __webpack_public_path__ + "img/9788957983713.48db8d13.jpg";